import { SearchResultIdQueryParam } from './constants/constants';
import { removeFilters } from './eventQueryUtils';

export const createPurchaseSearchPageUrl = (
  isV2 = false,
  searchResultId?: string,
  queryParamsToRemove?: string[] // queryParams to remove from final URL
): string => {
  let searchParams = '';
  const url = new URL(window.location.href);

  if (searchResultId) {
    url.searchParams.set(SearchResultIdQueryParam, searchResultId);
  }
  (queryParamsToRemove ?? []).forEach((param) =>
    url.searchParams.delete(param)
  );
  searchParams = `?${removeFilters(url.searchParams.toString(), [
    'searchText',
  ])}`;
  return `/purchases/search${isV2 ? '-v2' : ''}${searchParams}`;
};

export const createSaleSearchPageUrl = (
  isV2 = false,
  searchResultId?: string,
  queryParamsToRemove?: string[] // queryParams to remove from final URL
): string => {
  let searchParams = '';
  const url = new URL(window.location.href);

  if (searchResultId) {
    url.searchParams.set(SearchResultIdQueryParam, searchResultId);
  }
  (queryParamsToRemove ?? []).forEach((param) =>
    url.searchParams.delete(param)
  );
  searchParams = `?${removeFilters(url.searchParams.toString(), [
    'searchText',
  ])}`;
  return `/sales/search${isV2 ? '-v2' : ''}${searchParams}`;
};

export const createInventorySearchPageUrl = (
  isV2 = false,
  searchResultId?: string,
  queryParamsToRemove?: string[] // queryParams to remove from final URL
): string => {
  let searchParams = '';
  const url = new URL(window.location.href);

  if (searchResultId) {
    url.searchParams.set(SearchResultIdQueryParam, searchResultId);
  }
  (queryParamsToRemove ?? []).forEach((param) =>
    url.searchParams.delete(param)
  );
  searchParams = `?${removeFilters(url.searchParams.toString(), [
    'searchText',
  ])}`;
  return `/inventory/search${isV2 ? '-v2' : ''}${searchParams}`;
};
